import React from 'react';
import PropTypes from 'prop-types';
import { replace } from '../../utils/func';
import styles from './PriceBlock.module.scss';
import { getValidDiscountPercentage } from '../../utils/discountHelper';

const PriceBlock = ({ previousPrice, currentPrice, inSlider, product }) => {
  let regularPrice = `${styles.regularPrice}`;
  let currentPriceStyle = `${styles.currentPrice}`;
  let previousPriceStyle = `${styles.previousPrice}`;

  if (inSlider) {
    regularPrice = `${styles.regularPrice} ${styles.regularPrice__slider}`;
    currentPriceStyle = `${styles.currentPrice} ${styles.currentPrice__slider}`;
    previousPriceStyle = `${styles.previousPrice} ${styles.previousPrice__slider}`;
  }

  // Розраховуємо знижку тільки від поточної ціни
  let finalCurrentPrice = currentPrice;
  let finalPreviousPrice = null;
  let discountPercentage = 0;

  if (product) {
    discountPercentage = getValidDiscountPercentage(product);
    
    if (discountPercentage > 0) {
      // Якщо є знижка, показуємо оригінальну ціну як попередню
      // і розраховуємо нову ціну зі знижкою від поточної ціни
      finalPreviousPrice = currentPrice;
      finalCurrentPrice = Math.round(currentPrice * (1 - discountPercentage / 100));
    }
  }

  return (
    <>
      {discountPercentage > 0 ? (
        <div className={styles.priceSales}>
          <div data-testid='newPrice' className={currentPriceStyle}>
            {replace(finalCurrentPrice)} грн
          </div>
          <div data-testid='prevPrice' className={previousPriceStyle}>
            {replace(finalPreviousPrice)} грн
          </div>
          <div className={styles.discountPercentage}>
            -{discountPercentage}%
          </div>
        </div>
      ) : (
        <div className={regularPrice}>{replace(finalCurrentPrice)} грн</div>
      )}
    </>
  );
};

PriceBlock.propTypes = {
  currentPrice: PropTypes.number.isRequired,
  previousPrice: PropTypes.number,
  inSlider: PropTypes.bool,
  product: PropTypes.object,
};
PriceBlock.defaultProps = {
  previousPrice: null,
  inSlider: false,
  product: null,
};

export default PriceBlock;
